import styled from "@emotion/styled";
import { ComponentType } from "react";

export function withDisabledCopy<T extends {}>(Component: ComponentType<T>) {
  const ComponentWithDisabledCopy = (props: T) => {
    return (
      <QuestionWrapper
        onCopy={(e) => {
          e.preventDefault();
        }}
        onDragStart={(e) => {
          e.preventDefault();
        }}
        onCut={(e) => {
          e.preventDefault();
        }}
      >
        <Component {...(props as T)} />
      </QuestionWrapper>
    );
  };
  return ComponentWithDisabledCopy;
}

const QuestionWrapper = styled.div`
  height: 100%;
`;
